/**
 * @flow
 * @format
 */

import _FieldMessage from './FieldMessage';

export default _FieldMessage;



// WEBPACK FOOTER //
// ./src/components/FieldMessage/index.js